/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { replace } from 'react-router-redux';
import qs from 'qs';
import { Link, withRouter } from 'react-router';
import { withTranslation } from 'react-i18next';
import { markdownToDraft } from 'markdown-draft-js';
import { EditorState, convertFromRaw } from 'draft-js';
import Auth from '@aws-amplify/auth';
import {
  Dimmer,
  Dropdown,
  Grid,
  Label,
  Table,
  Loader,
  Icon,
  Header,
  Popup,
  Button,
  Accordion,
  Input,
  Transition,
} from 'semantic-ui-react';

import config from '../../../config';
import { decodeSearch, encodeSearch } from '../../utils/url';
import isbase64 from '../../utils/isbase64';
import BookingDatePicker from '../UpdatedComponents/UCBookingDatePicker';
import { BookingSelectList } from '../UpdatedComponents/UCBookingSelectList';
import { BookingSelectListMultiple } from '../UpdatedComponents/UCBookingSelectListMultiple';
import { flashErrorMessage } from '../../actions/flash';
import { fetchM } from '../../actions/fetchM';
import { isVietnamCompany } from '../../utils/vietnam';
import { exportFiltersFromQuery, exportsPagePath } from '../../utils/vnBookingExport';
import PageNav from './../PageNav';
import SearchIn from '../UpdatedComponents/UCSearchIn';
import SortButton from './../UpdatedComponents/UCSortButton';
import Timestamp from './../Timestamp';
import FixedBarStatus from '../UpdatedComponents/UCFixedBarStatus';
import { DEVELOPER_CANCELLED } from '../../constants/lawyerCaseStatuses';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import BookingStatusDropdown from '../UpdatedComponents/UCBookingStatusDropdown';
import DownloadSvg from '../../assets/icons/download.svg';
import SortSvg from '../../assets/icons/sort.svg';
import LoanGreen from '../../assets/icons/loan_green.svg';
import DocumentBlackSvg from '../../assets/icons/document_black.svg';
import CreditCardDisabledSvg from '../../assets/icons/credit_card_disabled.svg';
import CreditCardYellowSvg from '../../assets/icons/credit_card_yellow.svg';
import CreditCardGreenSvg from '../../assets/icons/credit_card_green.svg';
import LoanDisabledSvg from '../../assets/icons/loan_disabled.svg';
import InfoPopup from '../UpdatedComponents/Basic/UCBPopup';
import StatusFlag from '../UpdatedComponents/Basic/UCBStatusFlag';
import { DEFAULT_OPPORTUNITY_STATUS, OPPORTUNITY_STATUS, OPPORTUNITY_STATUS_MAP, OPPORTUNITY_STATUSES_TABS, OPPORTUNITY_STATUS_GROUP, SINGLE_STATUS_FILTER_OPTIONS, SINGLE_STATUS_MAP, SINGLE_STATUS_TAB_VALUES } from '../../constants/opportunityStatuses';
import { PAYMENT_REFUND_STATUSES } from '../../constants/paymentRefundStatuses';
import { SOURCE_OF_FINANCE_STATUS_MAP, SOURCE_OF_FINANCE_STATUSES } from '../../constants/sourceOfFinanceStatuses';
import { titleCase } from '../../utils/strings';
import { formatMinorAmount } from '../../utils/numbers/currencyMinor';

const allFilterNames = [
  'search',
  'searchIn',
  'customer_name',
  'dateRange',
  'dateFrom',
  'dateTo',
  'pendingApprovalDateRange',
  'pendingApprovalDateFrom',
  'pendingApprovalDateTo',
  'approvedDateRange',
  'approvedDateFrom',
  'approvedDateTo',
  'pendingRejectionDateRange',
  'pendingRejectionDateFrom',
  'pendingRejectionDateTo',
  'rejectedDateRange',
  'rejectedDateFrom',
  'rejectedDateTo',
  'pendingCancellationDateRange',
  'pendingCancellationDateFrom',
  'pendingCancellationDateTo',
  'cancelledDateRange',
  'cancelledDateFrom',
  'cancelledDateTo',
  'pendingRefundDateRange',
  'pendingRefundDateFrom',
  'pendingRefundDateTo',
  'refundedDateRange',
  'refundedDateFrom',
  'refundedDateTo',
  'paymentStatus',
  'paymentRefundStatus',
  'sourceOfFinance',
  'loanStatus',
  'filteredProjects',
  'token_status_id',
  'sr_code',
];

const urtColorMap = {
  pending_payment: null,
  partially_paid: 'yellow',
  paid_unverified: 'orange',
  paid_verified: 'green',
  expired: 'grey',
  partially_refunded: 'blue',
  refunded: 'blue',
  cancelled: 'red',
};

class OpportunityList extends Component {
  static contextTypes = {
    store: PropTypes.object,
    router: PropTypes.object,
  }
  static propTypes = {
    where: PropTypes.shape({}),
    projectUnitID: PropTypes.string,
    onLoading: PropTypes.func,
    noScrollTop: PropTypes.bool,
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isBranchLeader: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isBranchLeaderSupervisor: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      groups: PropTypes.arrayOf(PropTypes.shape({
        code: PropTypes.string,
      })),
      companyBranch: PropTypes.shape({
        isExternal: PropTypes.bool,
      }),
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
    }),
    t: PropTypes.func,
  }
  static defaultProps = {
    hideBookingList: false,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
    appConfig: state.appConfig,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const currentPage = parseInt(query.page, 10) || 1;
    const sr_code = query.sr_code || '';
    const customer_name = query.customer_name || '';
    const search = query.search || '';
    const searchIn = query.searchIn || '';
    const dateRange = query.dateRange || '';
    const dateFrom = query.dateFrom ? query.dateFrom : '';
    const dateTo = query.dateTo ? query.dateTo : '';
    const pendingApprovalDateRange = query.pendingApprovalDateRange || '';
    const pendingApprovalDateFrom = query.pendingApprovalDateFrom ? query.pendingApprovalDateFrom : '';
    const pendingApprovalDateTo = query.pendingApprovalDateTo ? query.pendingApprovalDateTo : '';
    const approvedDateRange = query.approvedDateRange || '';
    const approvedDateFrom = query.approvedDateFrom ? query.approvedDateFrom : '';
    const approvedDateTo = query.approvedDateTo ? query.approvedDateTo : '';
    const pendingRejectionDateRange = query.pendingRejectionDateRange || '';
    const pendingRejectionDateFrom = query.pendingRejectionDateFrom ? query.pendingRejectionDateFrom : '';
    const pendingRejectionDateTo = query.pendingRejectionDateTo ? query.pendingRejectionDateTo : '';
    const rejectedDateRange = query.rejectedDateRange || '';
    const rejectedDateFrom = query.rejectedDateFrom ? query.rejectedDateFrom : '';
    const rejectedDateTo = query.rejectedDateTo ? query.rejectedDateTo : '';
    const pendingCancellationDateRange = query.pendingCancellationDateRange || '';
    const pendingCancellationDateFrom = query.pendingCancellationDateFrom ? query.pendingCancellationDateFrom : '';
    const pendingCancellationDateTo = query.pendingCancellationDateTo ? query.pendingCancellationDateTo : '';
    const cancelledDateRange = query.cancelledDateRange || '';
    const cancelledDateFrom = query.cancelledDateFrom ? query.cancelledDateFrom : '';
    const cancelledDateTo = query.cancelledDateTo ? query.cancelledDateTo : '';
    const pendingRefundDateRange = query.pendingRefundDateRange || '';
    const pendingRefundDateFrom = query.pendingRefundDateFrom ? query.pendingRefundDateFrom : '';
    const pendingRefundDateTo = query.pendingRefundDateTo ? query.pendingRefundDateTo : '';
    const refundedDateRange = query.refundedDateRange || '';
    const refundedDateFrom = query.refundedDateFrom ? query.refundedDateFrom : '';
    const refundedDateTo = query.refundedDateTo ? query.refundedDateTo : '';
    const opportunityStatus = query.group_status || '';
    const srStatus = query.sr_status || '';
    const tokenStatus = query.token_status_id || '';
    const paymentStatus = query.paymentStatus || [];
    const paymentRefundStatus = query.paymentRefundStatus || [];
    const sourceOfFinance = query.sourceOfFinance || '';
    const loanStatus = query.loanStatus || [];
    const projectFilter = (isbase64(query.projectFilter) && qs.parse(atob(query.projectFilter)).name) || '';
    const staffFilter = (isbase64(query.staffFilter) && qs.parse(atob(query.staffFilter)).name) || ''; // change?
    const loadingProjectSearch = false;
    const loadingStaffSearch = false;
    const findProjectResults = [];
    const findStaffResults = [];
    const loadingMessage = `${props.t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    const noResultsMessage = loadingMessage;
    const noStaffResultsMessage = loadingMessage;
    // const hasAccess = props.auth.isHeadquarters || props.auth.isSuperAdmin;
    const screenWidth = window.innerWidth;
    return {
      search,
      searchIn,
      sr_code,
      dateRange,
      dateTo,
      dateFrom,
      pendingApprovalDateRange,
      pendingApprovalDateFrom,
      pendingApprovalDateTo,
      approvedDateRange,
      approvedDateFrom,
      approvedDateTo,
      pendingRejectionDateRange,
      pendingRejectionDateFrom,
      pendingRejectionDateTo,
      rejectedDateRange,
      rejectedDateFrom,
      rejectedDateTo,
      pendingCancellationDateRange,
      pendingCancellationDateFrom,
      pendingCancellationDateTo,
      cancelledDateRange,
      cancelledDateFrom,
      cancelledDateTo,
      pendingRefundDateRange,
      pendingRefundDateFrom,
      pendingRefundDateTo,
      refundedDateRange,
      refundedDateFrom,
      refundedDateTo,
      opportunityStatus,
      tokenStatus,
      paymentStatus,
      paymentRefundStatus,
      sourceOfFinance,
      loanStatus,
      projectFilter,
      staffFilter,
      loadingProjectSearch,
      loadingStaffSearch,
      findProjectResults,
      findStaffResults,
      noResultsMessage,
      noStaffResultsMessage,
      currentPage,
      stringifyQuery: '',
      screenWidth,
      srStatus,
      customer_name,
    };
  }
  static summaryDefault = {
    all: 0,
    pending_approval: 0,
    approved: 0,
    pending_closure: 0,
    pending_refund: 0,
    closed: 0,
  }
  constructor(props) {
    super(props);
    const state = OpportunityList.getPropsToState(props);
    const summary = Object.assign({}, OpportunityList.summaryDefault);
    this.state = {
      ...state,
      loading: true,
      count: 0,
      limit: 0,
      offset: 0,
      // for opportunity listing
      cursorPaginations: [],     // stack of { pit_id, search_after } per visited page (for Prev)
      currentPageCursor: null,   // cursor used to fetch the currently displayed page
      nextCursor: null,          // cursor from latest API response (used to fetch next page)
      data: [],
      summary,
      mpUserLoading: false,
      mpUserDetails: {},
      isChanging: false,
      projectOpts: [],
      filteredProjects: [],
      activeAccordionIndex: -1,
      isMobile: state.screenWidth <= 767,
      isTablet: state.screenWidth > 767 && state.screenWidth <= 991,
      isComputer: state.screenWidth > 991,
      projectArData: [],
      srCodeInput: '',
      customerNameInput: '',
      systemData: [],
      allBankCases: [],
      hasDropCase: false,
      loadingCount: 0,
    };
  }
  componentDidMount() {
    const query = decodeSearch(this.props.location.search);

    if (query.sr_code) {
      this.setState({ srCodeInput: query.sr_code });
    }
    if (query.customer_name) {
      this.setState({ customerNameInput: query.customer_name });
    }
    this.fetchSystemSettings();
    this.fetchProjects();
    this.replaceQuery(query, true, false);
    this.handleResize();
    this.setStickyWidth();
    this.updateStickyShadows();
    window.addEventListener('resize', this.handleResize);
    window.addEventListener('resize', this.setStickyWidth);
    window.addEventListener('resize', this.updateStickyShadows);
  }
  componentWillReceiveProps(nextProps) {
    const oldQuery = decodeSearch(this.props.location.search) || {};
    const nextQuery = decodeSearch(nextProps.location.search) || {};
    if (nextQuery.sr_code !== oldQuery.sr_code) {
      this.setState({
        srCodeInput: nextQuery.sr_code || '',
      });
    }
    if (nextQuery.customer_name !== oldQuery.customer_name) {
      this.setState({
        customerNameInput: nextQuery.customer_name || '',
      });
    }
    const state = OpportunityList.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  componentWillUnmount() {
    if (this.setTimer) {
      clearTimeout(this.setTimer);
    }
    if (this.setStaffTimer) {
      clearTimeout(this.setStaffTimer);
    }
    this.clearPitExpireTimer();
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('resize', this.setStickyWidth);
    window.removeEventListener('resize', this.updateStickyShadows);
  }
  // True while an sr_status-driven tab is the filter; none is, since CPI-1226 re-pointed Error.
  isSingleStatusTabActive = () => (
    this.state.opportunityStatus === '' && SINGLE_STATUS_TAB_VALUES.indexOf(this.state.srStatus) > -1
  )
  getStatusCount = (status) => {
    const { summary } = this.state;
    if (this.state.loading || !summary) {
      return '...';
    }
    if (SINGLE_STATUS_TAB_VALUES.indexOf(status) > -1) {
      return this.getIndividualStatusCount(status);
    }
    switch (status) {
      case OPPORTUNITY_STATUS_GROUP.TOTAL:
        return summary.all || 0;
      case OPPORTUNITY_STATUS_GROUP.PENDING_APPROVAL:
        return summary.pending_approval ? summary.pending_approval.count : 0;
      case OPPORTUNITY_STATUS_GROUP.APPROVED:
        return summary.approved ? summary.approved.count : 0;
      case OPPORTUNITY_STATUS_GROUP.PENDING_CLOSURE:
        return summary.pending_closure ? summary.pending_closure.count : 0;
      case OPPORTUNITY_STATUS_GROUP.CLOSED:
        return summary.closed ? summary.closed.count : 0;
      case OPPORTUNITY_STATUS_GROUP.ERROR:
        return summary.error ? summary.error.count : 0;
      case OPPORTUNITY_STATUS_GROUP.PENDING_REFUND:
        return summary.pending_refund ? summary.pending_refund.count : 0;
      default:
        return 0;
    }
  }
  getSelectedStatus = (status) => {
    const { opportunityStatus, srStatus } = this.state;
    if (SINGLE_STATUS_TAB_VALUES.indexOf(status) > -1) {
      return opportunityStatus === '' && srStatus === status;
    }
    if (status === 'total') {
      // All Bookings must go dark while an sr_status tab is active - both clear group_status.
      return opportunityStatus === '' && !this.isSingleStatusTabActive();
    } else if (opportunityStatus !== '') {
      return opportunityStatus === status;
    }
    return false;
  }
  getTabHeader = () => {
    const { opportunityStatus } = this.state;
    const { t } = this.props;
    const statusValue = (this.isSingleStatusTabActive() && this.state.srStatus)
      || opportunityStatus
      || DEFAULT_OPPORTUNITY_STATUS;
    // group_status comes off the URL with no allow-list, so fall back rather than index undefined.
    const tab = OPPORTUNITY_STATUSES_TABS.find(status => statusValue === status.value)
      || OPPORTUNITY_STATUS_MAP[DEFAULT_OPPORTUNITY_STATUS];
    return t(tab.header, { ns: TRANSLATION_FILES.constants });
  }
  getBankCaseStatusColor = (status) => {
    if (status.startsWith('reject')) {
      return 'red';
    } else if (status.startsWith('pending')) {
      return 'yellow';
    } else if (status.startsWith('approved') || status.startsWith('success')) {
      return 'green';
    }
    return 'blue';
  }
  getBankCaseStatuses = (data) => {
    const values = [];
    if (data.bankCasesStatuses) {
      data.bankCasesStatuses.forEach((bcs) => {
        values.push({
          iconColor: this.getBankCaseStatusColor(bcs.status),
          value: bcs.bankShortName,
        });
      });
    }
    return values;
  }
  setMPUserLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ mpUserLoading: loading }, () => {
        res(loading);
      });
    });
  }
  setLoadingProjectSearch(loadingProjectSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingProjectSearch }, res);
    });
  }
  setLoadingStaffSearch(loadingStaffSearch = false) {
    return new Promise((res) => {
      this.setState({ loadingStaffSearch }, res);
    });
  }
  setBookings(data = []) {
    return new Promise((res) => {
      this.setState({
        data: data || [],
      }, () => {
        res(data);
      });
    });
  }
  setComponentState(state = {}) {
    return new Promise((res) => {
      this.setState(state, () => {
        res(state);
      });
    });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState((prev) => {
        const count = prev.loadingCount || 0;

        const newCount = loading
          ? count + 1
          : Math.max(count - 1, 0); // prevent negative

        const newLoading = newCount > 0;

        return {
          loadingCount: newCount,
          loading: newLoading,
        };
      }, () => {
        if (this.props.onLoading) {
          this.props.onLoading(this.state.loading);
        }
        res(this.state.loading);
      });
    });
  }
  getRowClassName = (statusID) => {
    if (statusID === 'cancelled_availability') {
      return 'row-colors booking_row_cancelled_availability';
    }
    if (statusID === 'cancelled_developer' || statusID === DEVELOPER_CANCELLED) {
      return 'row-colors booking_row_cancelled_developer';
    }
    return 'row-colors';
  }
  getAgingColor = (days = 0) => {
    if (days >= 30) {
      return 'red';
    }
    if (days >= 14) {
      return 'yellow';
    }
    return null;
  }
  getBookingIcon = (bookingStatus) => {
    switch (bookingStatus) {
      case OPPORTUNITY_STATUS.PAID_UNVERIFIED:
      case OPPORTUNITY_STATUS.PAID_VERIFIED:
      case OPPORTUNITY_STATUS.APPROVED:
      case OPPORTUNITY_STATUS.PAYMENT_MADE:
        return CreditCardGreenSvg;
      case OPPORTUNITY_STATUS.PARTIALLY_PAID_UNVERIFIED:
        return CreditCardYellowSvg;
      default:
        return CreditCardDisabledSvg;
    }
  }
  getSourceOfFinanceIcon = (FinanceSource) => {
    switch (FinanceSource) {
      case 'bank_loan':
        return LoanGreen;
      default:
        return LoanDisabledSvg;
    }
  }
  getAllFilterNames = (removeBookingStatus = false) => {
    if (removeBookingStatus) return allFilterNames.filter(fn => fn !== 'bookingStatusMulti');
    return allFilterNames;
  }
  getDataTarget = idx => ({ 'data-bot-target': `row${idx + 1}-bookinglist` });
  getDatasetAttributes = (daname, davalue) => {
    let newDavalue = davalue;
    if (newDavalue === '') newDavalue = 'NULL';
    if (newDavalue === 'Not Applicable') newDavalue = 'N/A';
    const datasetName = `data-bot-${daname}`;
    return {
      [datasetName]: newDavalue,
    };
  }
  setStickyWidth = () => {
    const table = document.querySelector('table');

    if (!table) return;

    if (this.isTableOverflowing(table)) {
      // Table is overflowing - apply sticky
      document.querySelectorAll('tr').forEach((row) => {
        // Left sticky
        const stickyLeftCols = Array.from(row.querySelectorAll('.uc-sticky-col.uc-left'));
        let cumulativeLeft = 0;
        stickyLeftCols.forEach((colParam) => {
          const col = colParam;
          col.style.left = `${cumulativeLeft}px`;
          cumulativeLeft += col.offsetWidth;
        });

        // Right sticky
        const stickyRightCols = Array.from(row.querySelectorAll('.uc-sticky-col.uc-right')).reverse();
        let cumulativeRight = 0;
        stickyRightCols.forEach((colParam) => {
          const col = colParam;
          col.style.right = `${cumulativeRight}px`;
          cumulativeRight += col.offsetWidth;
        });
      });

      // Enable shadows
      table.classList.add('has-overflow');
    } else {
      // No overflow - reset positions
      document.querySelectorAll('.uc-sticky-col').forEach((colElem) => {
        const col = colElem;
        col.style.left = '';
        col.style.right = '';
      });

      // Disable shadows
      table.classList.remove('has-overflow');
    }
  };
  getAllBankCases = (bankCases, bankCaseDrops) => {
    let hasDropCase = false;
    let allCases = [];
    if (bankCases) {
      const bankerIDs = new Set(bankCases.map(bc => bc.bankerID));
      allCases = bankCaseDrops ? [...bankCases, ...bankCaseDrops.filter((bcd) => {
        if (!bankerIDs.has(bcd.bankerID)) {
          hasDropCase = true;
          return true;
        }
      })] : [...bankCases];
    } else if (bankCaseDrops) {
      allCases = [...bankCaseDrops];
      hasDropCase = true;
    }

    return {
      ...allCases,
      hasDropCase,
    };
  }
  async fetchSystemSettings() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM('/settings/', {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const systemData = await res.json();
      await this.setState({
        systemData,
      });
    }
  }
  async fetchProjects() {
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({
      limit: 0,
      showAsOptions: false,
    });
    await this.setLoading(true);
    let res;

    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      let newProjectOpts = this.state.projectOpts;
      let newProjectArData = this.state.projectArData;
      if (data && data.length > 0) {
        newProjectOpts = data.map(d => ({ value: d.id, text: d.name }));
        newProjectArData = data.map(d => ({ ...d }));
      }
      await this.setComponentState({ projectOpts: newProjectOpts, projectArData: newProjectArData });
    }
    await this.setLoading(false);
  }
  async fetchBookingSummaries(q = {}) {
    await this.setLoading(true);
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign(q, {});
    if (this.props.projectUnitID) {
      query.projectUnitID = this.props.projectUnitID;
    }
    if (q && q.sr_code) {
      query.sr_code = q.sr_code;
    } else if (this.state.sr_code) {
      query.sr_code = this.state.sr_code;
    } else {
      delete query.sr_code;
    }
    if (query.limit) delete query.limit;
    if (query.pit_id) delete query.pit_id;
    if (query.search_after) delete query.search_after;

    let res;
    try {
      res = await store.dispatch(fetchM(`/opportunity/summary/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      await this.setLoading(false);
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const summary = await res.json();
      // handle token.. etc
      await this.setComponentState({ summary });
    }
    await this.setLoading(false);
  }
  async fetchBookings(q = {}) {
    await this.setLoading(true);
    const { t } = this.props;
    const { opportunityStatus } = this.state;
    const { store } = this.context;
    const query = Object.assign({}, q);

    if (query.sortColumn) {
      query.sort_by = query.sortColumn;
      query.sort_order = query.sortDirection;

      delete query.sortColumn;
      delete query.sortDirection;
    } else {
      delete query.sort_by;
      delete query.sort_order;
    }
    const effectiveTokenStatus = query.token_status_id || this.state.tokenStatus;
    const isTokenFilter = !!effectiveTokenStatus && effectiveTokenStatus !== 'pending_payment';

    let res;

    if (this.props.projectUnitID) {
      query.projectUnitID = this.props.projectUnitID;
    }
    const srCode = typeof query.sr_code === 'string' ? query.sr_code.trim() : '';

    if (srCode) {
      query.sr_code = srCode;
    } else {
      delete query.sr_code;
    }

    if (isTokenFilter) {
      query.token_status_id = effectiveTokenStatus;
      query.page = Math.max(1, parseInt(query.page, 10) || 1);
      delete query.pit_id;
      delete query.search_after;
      delete query.sr_status;
    } else {
      if (opportunityStatus) {
        query.group_status = opportunityStatus;
      }
      if (this.state.srStatus) {
        query.sr_status = this.state.srStatus;
      }
      delete query.token_status_id;
      delete query.page;
    }

    query.limit = 30;
    const url = `/opportunity/?${qs.stringify(query)}`;
    const urlOptions = {
      credentials: 'include',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    try {
      res = await store.dispatch(fetchM(url, urlOptions));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoading(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const limit = parseInt(res.headers.get('M-Data-Limit'), 10);
      const data = await res.json();

      await this.setBookings(data.opportunities);

      if (isTokenFilter) {
        const count = parseInt(res.headers.get('M-Data-Count'), 10) || 0;
        const offset = parseInt(res.headers.get('M-Data-Offset'), 10) || 0;
        this.setState({ limit, count, offset, nextCursor: null });
      } else {
        const newCursor = (data.search_after && data.opportunities && data.opportunities.length === limit)
          ? { pit_id: data.pit_id, search_after: data.search_after }
          : null;
        this.setState({ limit, nextCursor: newCursor });
      }
    }
    await this.setLoading(false);
    this.setStickyWidth();
    this.updateStickyShadows();
  }
  handleResize = () => {
    const screenWidth = window.innerWidth;

    this.setState({
      screenWidth,
      isMobile: screenWidth <= 767,
      isTablet: screenWidth > 767 && screenWidth <= 991,
      isComputer: screenWidth > 991 });
  }
  isTableOverflowing = (table) => {
    const parent = table.parentElement;
    return table.scrollWidth > parent.clientWidth;
  }
  updateStickyShadows = () => {
    // Remove old shadow classes
    document.querySelectorAll('.uc-sticky-shadow-left, .uc-sticky-shadow-right').forEach((el) => {
      el.classList.remove('uc-sticky-shadow-left', 'uc-sticky-shadow-right');
    });

    // Loop over all table rows
    document.querySelectorAll('tr').forEach((row) => {
      // Find the first sticky LEFT cell in this row
      const firstStickyLeft = row.querySelector('th.uc-sticky-col.uc-left, td.uc-sticky-col.uc-left');
      if (firstStickyLeft) {
        firstStickyLeft.classList.add('uc-sticky-shadow-left');
      }

      // Find the first sticky RIGHT cell in this row
      const firstStickyRight = row.querySelector('th.uc-sticky-col.uc-right, td.uc-sticky-col.uc-right');
      if (firstStickyRight) {
        firstStickyRight.classList.add('uc-sticky-shadow-right');
      }
    });
  }
  handleAccordionClick(e, valIndex) {
    const { index } = valIndex;
    this.setState(prevState => ({
      activeAccordionIndex: prevState.activeAccordionIndex === index ? -1 : index,
    }));
  }
  hasAccess(check = false) {
    if (
      this.props.auth.isBranchLeader ||
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  hasAdminAccess(check = false) {
    if (
      this.props.auth.isHeadquarters ||
      this.props.auth.isSuperAdmin
    ) {
      return true;
    }
    return check;
  }
  hasInternalDEAccess(check = false) {
    const auth = this.props.auth;
    if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return check;
  }
  hasStaffAccess(check = false) {
    if (
      this.props.auth.isSuperAdmin ||
      this.props.auth.isHeadquarters
    ) {
      return true;
    }
    return check;
  }
  handlePageChange = (param) => {
    const { type, cursor } = param;
    // cursor params live in state only — never read from URL
    const query = decodeSearch(this.props.location.search);

    if (type === 'next') {
      // Save the cursor used to reach the current page so Prev can return here
      this.setState(prev => ({
        cursorPaginations: [...prev.cursorPaginations, prev.currentPageCursor],
        currentPageCursor: cursor,
      }), () => {
        const fetchQuery = cursor
          ? { ...query, pit_id: cursor.pit_id, search_after: cursor.search_after }
          : { ...query };
        this.resetPitExpireTimer();
        this.fetchBookings(fetchQuery);
      });
    } else if (type === 'prev') {
      this.setState((prev) => {
        const newStack = [...prev.cursorPaginations];
        const prevCursor = newStack.length > 0 ? newStack.pop() : null;
        return { cursorPaginations: newStack, currentPageCursor: prevCursor };
      }, () => {
        const { currentPageCursor } = this.state;
        const fetchQuery = currentPageCursor
          ? { ...query, pit_id: currentPageCursor.pit_id, search_after: currentPageCursor.search_after }
          : { ...query };
        if (currentPageCursor) {
          this.resetPitExpireTimer();
        } else {
          // Back to page 1 — no active PIT to track
          this.clearPitExpireTimer();
        }
        this.fetchBookings(fetchQuery);
      });
    }
  };
  handleChangePageOffset = (currentPage) => {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({ currentPage });
    store.dispatch(replace(`${pathname}?${encodeSearch(query)}`));
    this.fetchBookings(query);
  }
  handleTokenStatusFilter = (value) => {
    const query = decodeSearch(this.props.location.search);
    if (value) {
      query.token_status_id = value;
    } else {
      delete query.token_status_id;
    }
    delete query.page;
    this.setState({ currentPage: 1 }, () => {
      this.replaceQuery(query, true, true);
    });
  }
  resetPitExpireTimer = () => {
    if (this.pitExpireTimer) {
      clearTimeout(this.pitExpireTimer);
    }
    // PIT lasts 4 minutes; reset cursor history so next/prev interaction goes back to page 1
    this.pitExpireTimer = setTimeout(() => {
      this.setState({ cursorPaginations: [], nextCursor: null, currentPageCursor: null });
    }, 4 * 60 * 1000);
  };
  clearPitExpireTimer = () => {
    if (this.pitExpireTimer) {
      clearTimeout(this.pitExpireTimer);
      this.pitExpireTimer = null;
    }
  };
  handleSortData = (sortColumn, sortDirection) => {
    const query = decodeSearch(this.props.location.search);
    query.sortColumn = sortColumn;
    query.sortDirection = sortDirection;

    // Reset cursor stack because sorting changes the order
    this.replaceQuery(query, true, true);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    let clearSearch = false;
    const query = decodeSearch(this.props.location.search);

    queryArray.forEach((filter) => {
      if (filter === 'sr_code') {
        this.setState({ sr_code: '', srCodeInput: '' });
      }
      if (filter === 'customer_name') {
        this.setState({ customer_name: '', customerNameInput: '' });
      }
      if (filter === 'search') clearSearch = true;

      if (filter === 'agingRange' || filter === 'loanStatus') {
        delete query.sortColumn;
        delete query.sortDirection;
      }

      if (filter === 'filteredProjects') {
        delete query.projectCode;
        delete query.projectFilter;
        hasQuery = true;
        this.setState({ filteredProjects: [], isChanging: false });
      }

      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        this.setState({ isChanging: false });
      }
    });

    const cb = () => {
      if (hasQuery) {
        // reset cursor stack when filters change
        this.replaceQuery(query, true, true);
      }
    };

    if (clearSearch) {
      this.setState({ search: '' }, cb);
    } else {
      cb();
    }
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    if (queryName === 'sr_code') {
      const trimmedValue = value ? value.trim() : '';

      delete query.group_status;
      delete query.sr_status;
      delete query.sortColumn;
      delete query.sortDirection;
      delete query.page;
      delete query.customer_name;

      if (trimmedValue !== '') {
        query[queryName] = trimmedValue;
      } else {
        delete query[queryName];
      }

      this.setState({
        sr_code: trimmedValue,
        opportunityStatus: null,
        customerNameInput: '',
        srStatus: null,
        currentPage: 1,
      });
    } else if (queryName === 'customer_name') {
      const trimmedValue = value ? value.trim() : '';

      delete query.page;

      if (trimmedValue !== '') {
        query[queryName] = trimmedValue;
      } else {
        delete query[queryName];
      }

      this.setState({
        customer_name: trimmedValue,
      });
    } else {
      query[queryName] = value;
      this.replaceQuery(query);
    }
    let refetch = queryName !== 'searchIn' || (queryName === 'searchIn' && this.state.search.length > 0);
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    if (queryName === 'cancelledDateRange' && query.cancelledDateRange === 'custom' && (!query.cancelledDateFrom || !query.cancelledDateTo)) {
      refetch = false;
    }
    if (queryName === 'expiredDateRange' && query.expiredDateRange === 'custom' && (!query.expiredDateFrom || !query.expiredDateTo)) {
      refetch = false;
    }
    if (queryName === 'bookedDateRange' && query.bookedDateRange === 'custom' && (!query.bookedDateFrom || !query.bookedDateTo)) {
      refetch = false;
    }
    if (queryName === 'soldDateRange' && query.soldDateRange === 'custom' && (!query.soldDateFrom || !query.soldDateTo)) {
      refetch = false;
    }

    this.replaceQuery(query, refetch, true);
  }
  handleSetDateRange = (name, from, to) => {
    const query = decodeSearch(this.props.location.search);
    switch (name) {
      case 'dateRange':
        query.dateFrom = from;
        query.dateTo = to;
        break;
      case 'pendingApprovalDateRange':
        query.pendingApprovalDateFrom = from;
        query.pendingApprovalDateTo = to;
        break;
      case 'approvedDateRange':
        query.approvedDateFrom = from;
        query.approvedDateTo = to;
        break;
      case 'pendingRejectionDateRange':
        query.pendingRejectionDateFrom = from;
        query.pendingRejectionDateTo = to;
        break;
      case 'rejectedDateRange':
        query.rejectedDateFrom = from;
        query.rejectedDateTo = to;
        break;
      case 'pendingCancellationDateRange':
        query.pendingCancellationDateFrom = from;
        query.pendingCancellationDateTo = to;
        break;
      case 'cancelledDateRange':
        query.cancelledDateFrom = from;
        query.cancelledDateTo = to;
        break;
      case 'pendingRefundDateRange':
        query.pendingRefundDateFrom = from;
        query.pendingRefundDateTo = to;
        break;
      case 'refundedDateRange':
        query.refundedDateFrom = from;
        query.refundedDateTo = to;
        break;
      default:
        break;
    }
    this.replaceQuery(query, true, true);
  }
  handleReplaceStatus = (status = '') => {
    const query = decodeSearch(this.props.location.search);
    if (status !== '' && status !== OPPORTUNITY_STATUS_GROUP.TOTAL) {
      query.group_status = status;
    } else {
      delete query.group_status;
    }
    delete query.sr_status;
    delete query.sr_code;
    delete query.customer_name;
    if (status !== OPPORTUNITY_STATUS_GROUP.PENDING_APPROVAL) {
      delete query.pendingApprovalDateRange;
      delete query.pendingApprovalDateFrom;
      delete query.pendingApprovalDateTo;
    }
    if (status !== OPPORTUNITY_STATUS_GROUP.APPROVED) {
      delete query.approvedDateRange;
      delete query.approvedDateFrom;
      delete query.approvedDateTo;
    }
    if (status !== OPPORTUNITY_STATUS_GROUP.PENDING_CLOSURE) {
      delete query.pendingRejectionDateRange;
      delete query.pendingRejectionDateFrom;
      delete query.pendingRejectionDateTo;
    }
    delete query.token_status_id;
    delete query.page;
    delete query.sortColumn;
    delete query.sortDirection;
    if (status !== OPPORTUNITY_STATUS_GROUP.PENDING_REFUND) {
      delete query.pendingRefundDateRange;
      delete query.pendingRefundDateFrom;
      delete query.pendingRefundDateTo;
    }
    if (status !== OPPORTUNITY_STATUS_GROUP.CLOSED && status !== OPPORTUNITY_STATUS_GROUP.ERROR) {
      delete query.cancelledDateRange;
      delete query.cancelledDateFrom;
      delete query.cancelledDateTo;
    }
    this.setState({ srCodeInput: '', customerNameInput: '' });
    this.replaceQuery(query, true, true);
  }

  handleSearchStaff = (value) => {
    const { t } = this.props;
    clearTimeout(this.setStaffTimer);
    const findStaffResults = [];
    const noStaffResultsMessage = `${t('Loading', { ns: TRANSLATION_FILES.translation })}...`;
    this.setState({ findStaffResults, noStaffResultsMessage, staffFilter: value }, () => {
      if (value !== '') {
        this.setStaffTimer = setTimeout(() => {
          this.searchStaffs(value);
        }, 500);
      }
    });
  }
  handleFilterProjects = (e, { name, value }) => {
    const filteredProjects = value;
    this.setState({ filteredProjects }, () => {
      const query = decodeSearch(this.props.location.search);
      query[name] = btoa(value);
      this.replaceQuery(query, true, true);
    });
  }
  handleSelectProject = (project, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = project.key;
    internalQuery.name = project.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true, true);
  }
  handleSelectStaff = (staff, queryName) => {
    const query = decodeSearch(this.props.location.search);
    const internalQuery = {};
    internalQuery.id = staff.key;
    internalQuery.name = staff.title;
    query[queryName] = btoa(qs.stringify(internalQuery));
    this.replaceQuery(query, true, true);
  }
  async searchStaffs(value) {
    const { store } = this.context;
    const { t } = this.props;
    await this.setLoadingStaffSearch(true);
    let res = null;
    try {
      res = await store.dispatch(fetchM(`/search/staffs/?isExternal=false&limit=3&search=${value}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      await this.setLoadingStaffSearch(false);
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
    }
    if (!res.ok) {
      await this.setLoadingStaffSearch(false);
      throw new Error('Not OK');
    } else {
      await this.setLoadingStaffSearch(false);
      const json = await res.json();
      if (json) {
        const findStaffResults = json.map((obj) => {
          const newResults = {};
          newResults.key = obj.id.toString();
          newResults.title = obj.name;
          newResults.price = obj.preferredName;
          newResults.description = obj.email;
          return newResults;
        });
        this.setState({ findStaffResults });
      } else {
        const noStaffResultsMessage = `${t('No results found', { ns: TRANSLATION_FILES.translation })}.`;
        this.setState({ noStaffResultsMessage });
      }
    }
  }
  replaceQuery = (query, fetch = true, resetCursor = false) => {
    const { store } = this.context;
    const { pathname } = this.props.location;
    const queryNew = Object.assign({}, query);

    // Cursor params must never appear in the URL
    delete queryNew.pit_id;
    delete queryNew.search_after;

    if (resetCursor) {
      this.setState({ cursorPaginations: [], nextCursor: null, currentPageCursor: null });
      this.clearPitExpireTimer();
    }

    if (fetch) {
      // Filter/sort fetches always restart from page 1 — no cursor needed
      this.fetchBookings(queryNew);
      this.fetchBookingSummaries(queryNew);
    }

    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  };
  exportURL = (fileType, primary = false, detailed = false) => {
    const { location, projectUnitID } = this.props;
    let url = `${config.get('bookApiURL')}/reports/bookings/`;
    if (location && location.search) {
      url += `${location.search}`;
    }
    if (projectUnitID) {
      url += `&projectUnitID=${projectUnitID}`;
    }
    if (primary) {
      url += '&primaryOnly=true';
    }
    url += `&fileType=${fileType}`;
    if (detailed) {
      url += '&detailed=true';
    }
    return url;
  }
  hasMPDetailsAccess = () => {
    const { auth } = this.props;
    return auth.isHeadquarters || auth.isBranchLeaderSupervisor;
  }
  cellCheckSorted = (column, isReversed = false) => {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);

    if (!sortColumn) {
      if (column === 'created_at') {
        return 'descending';
      }
    }

    if (column === sortColumn) {
      if (isReversed) {
        return sortDirection === 'asc' ? 'descending' : 'ascending';
      }
      return sortDirection === 'asc' ? 'ascending' : 'descending';
    }
    return null;
  }
  handleCellSort = (column) => {
    const { sortColumn, sortDirection } = decodeSearch(this.props.location.search);
    let direction = 'asc';
    if (column === sortColumn) {
      direction = sortDirection === 'asc' ? 'desc' : 'asc';
    }
    this.handleSortData(column, direction);
  }
  exportItemsAdmin = () => {
    if (this.hasAdminAccess() && this.state.currentTab !== 'aging_by_bankers') {
      const { location, projectUnitID } = this.props;
      let url = `${config.get('bookApiURL')}/reports/bookings/customer_details/`;
      if (location && location.search) {
        url += `${location.search}`;
      }
      if (projectUnitID) {
        url += `&projectUnitID=${projectUnitID}`;
      }
      return [
        {
          text: 'Excel\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=excel`,
        },
        {
          text: 'Excel\n(primary)\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=excel&primaryOnly=true`,
        },
        {
          text: 'CSV\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=csv`,
        },
        {
          text: 'CSV\n(primary)\nwith\nCustomer\nDetails',
          icon: 'download',
          href: `${url}&fileType=csv&primaryOnly=true`,
        },
      ];
    }
    return [];
  }
  exportItemsPrimary = () => {
    if (this.state.currentTab !== 'aging_by_bankers') {
      return [
        {
          text: 'Excel\n(primary)',
          icon: 'download',
          href: this.exportURL('excel', true),
        },
        {
          text: 'CSV\n(primary)',
          icon: 'download',
          href: this.exportURL('csv', true),
        },
      ];
    }
    return [];
  }
  handleSingleStatusOnChange = (singleStatusValue) => {
    const query = decodeSearch(this.props.location.search);

    if (singleStatusValue && singleStatusValue !== '__all__') {
      query.sr_status = singleStatusValue;
    } else {
      delete query.sr_status;
    }
    delete query.group_status;
    delete query.sr_code;
    delete query.page;
    delete query.sortColumn;
    delete query.sortDirection;
    delete query.customer_name;
    this.setState({ srCodeInput: '', customerNameInput: '' });

    this.replaceQuery(query, true, true);
  }
  exportItemsManager = () => {
    const isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
    if (this.hasAccess() && this.state.currentTab !== 'aging_by_bankers') {
      const query = decodeSearch(this.props.location.search);
      query.page = 'all';
      const exportItems = [
        {
          text: 'Full\nExcel',
          icon: 'download',
          href: `${config.get('bookApiURL')}/bookings/export/?${qs.stringify(query)}`,
          dataTarget: 'fullexcel',
        },
        {
          text: 'Updated Today',
          icon: 'download',
          href: `${config.get('bookApiURL')}/bookings/export/?page=all&updatedToday=true`,
          dataTarget: 'updatedtoday',
        },
        {
          isDivider: true,
        },
      ];
      if (this.state.currentTab === 'all' && isMalaysia) {
        exportItems.push(
          {
            text: 'Loan Approval',
            icon: 'download',
            href: `${config.get('bookApiURL')}/bookings/export/loan_approvals/?${qs.stringify(query)}`,
            dataTarget: 'loanapproval',
          },
          {
            text: 'Booking Notes',
            icon: 'download',
            href: `${config.get('bookApiURL')}/bookings/export/notes/?${qs.stringify(query)}`,
            dataTarget: 'bookingnotes',
          },
          {
            isDivider: true,
          },
        );
      }
      return exportItems;
    }
    return [];
  }
  checkGroupAccess = (groups) => {
    const roles = [
      { text: 'Headquarters', value: '10,6' },
      { text: 'Supervisor', value: '10,11,12,13' },
      { text: 'Sales Manager', value: '10,11,13' },
      { text: 'Sales Admin', value: '10,11' },
    ];
    const rolesArr = [];
    if (groups) {
      groups.forEach((g) => {
        rolesArr.push(g.id);
      });
      rolesArr.sort();
      const role = roles.find(g => g.value === String(rolesArr.toString()));
      if (role && role.text) {
        return role.text;
      }
    }
    return null;
  }
  hasLawyerSPASignedDate = (date) => {
    if (date) {
      if (date.length > 1 && date[1]) {
        return true;
      }
    }
    return false;
  }
  handlePrint = () => {
    Auth.currentSession();
  }
  statusDateSortItems = () => {
    const { opportunityStatus } = this.state;
    let label = '';
    let column = '';
    switch (opportunityStatus) {
      case 'cancelled_developer':
        label = 'Cancelled';
        column = 'l_cancelled_developer_at';
        break;
      case 'expired':
        label = 'Expired';
        column = 'l_expired_at';
        break;
      case 'booked':
        label = 'Booked';
        column = 'l_booked_at';
        break;
      case 'sold_spa_signed':
        label = 'Sold';
        column = 'l_sold_at';
        break;
      default:
        break;
    }
    return !this.props.projectUnitID && column ? [
      {
        text: `${label} Date Ascending`,
        icon: 'sort alphabet ascending',
        sortColumn: `booking.${column}`,
        sortDirection: 'asc',
      },
      {
        text: `${label} Date Descending`,
        icon: 'sort alphabet descending',
        sortColumn: `booking.${column}`,
        sortDirection: 'desc',
      },
    ] : [];
  }
  bookingNoteToMarkdown = (bNote) => {
    try {
      const hasNoSpaces = bNote.indexOf(' ') === -1;
      if (hasNoSpaces) {
        return decodeURIComponent(bNote.replace(/\+/g, ' '));
      }
      return decodeURIComponent(bNote);
    } catch (e) {
      return bNote;
    }
  };
  bookingNoteToEditorState = (bookingNote) => {
    const mdValue = this.bookingNoteToMarkdown(bookingNote);
    if (mdValue) {
      const rawData = markdownToDraft(mdValue, {
        preserveNewlines: true,
        blockStyles: {
          ins_open: 'UNDERLINE',
        },
        remarkableOptions: {
          enable: {
            inline: 'ins',
          },
        },
      });
      const contentState = convertFromRaw(rawData);
      const editorState = EditorState.createWithContent(contentState);
      return editorState;
    }
    return EditorState.createEmpty();
  }
  bookingNoteFormated = (bookingData) => {
    if (!bookingData) return '';
    if (!bookingData.latestBookingNote) return bookingData.remarkInternal; // deprecated old field
    // convert markdown to draft-js and then back to plaintext properly with custom formatings.
    const editorState = this.bookingNoteToEditorState(bookingData.latestBookingNote);
    const contentState = editorState.getCurrentContent();
    let plainText = contentState.getPlainText();
    const maxLength = 180;
    if (plainText && plainText.length > maxLength) {
      plainText = `${plainText.substring(0, maxLength)}...`;
    }
    return plainText;
  }
  getIndividualStatusCount = (statusKey) => {
    const { summary, loading } = this.state;
    if (loading || !summary) {
      return '...';
    }

    // 'error' is CPI-1226's group; without it the per-status count for cancelled_error reads 0.
    const macroGroups = ['pending_approval', 'approved', 'pending_closure', 'pending_refund', 'closed', 'error'];
    let totalCount = 0;

    macroGroups.forEach((group) => {
      if (
        summary[group] &&
        summary[group].statuses &&
        summary[group].statuses[statusKey] !== undefined
      ) {
        // Changed from = to += to accumulate numbers across groups safely
        totalCount += summary[group].statuses[statusKey];
      }
    });

    return totalCount;
  }
  hasBookingNote = (bookingData) => {
    if (bookingData && (bookingData.latestBookingNote || bookingData.remarkInternal)) return true;
    return false;
  }
  renderStatusDateFilter = () => {
    const { t } = this.props;
    const { opportunityStatus, loading, isMobile } = this.state;
    let filter = '';
    let filterFrom = '';
    let filterTo = '';
    let headerText = '';
    switch (opportunityStatus) {
      case OPPORTUNITY_STATUS.APPROVED:
        filter = 'approvedDateRange';
        filterFrom = 'approvedDateFrom';
        filterTo = 'approvedDateTo';
        headerText = 'Approved Date Range';
        break;
      case OPPORTUNITY_STATUS.PENDING_CANCELLATION:
        filter = 'pendingCancellationDateRange';
        filterFrom = 'pendingCancellationDateFrom';
        filterTo = 'pendingCancellationDateTo';
        headerText = 'Pending Cancellation Date Range';
        break;
      case OPPORTUNITY_STATUS_GROUP.ERROR:
        filter = 'cancelledDateRange';
        filterFrom = 'cancelledDateFrom';
        filterTo = 'cancelledDateTo';
        headerText = 'Cancelled Date Range';
        break;
      case OPPORTUNITY_STATUS.PENDING_REFUND:
        filter = 'pendingRefundDateRange';
        filterFrom = 'pendingRefundDateFrom';
        filterTo = 'pendingRefundDateTo';
        headerText = 'Pending Refund Date Range';
        break;
      case OPPORTUNITY_STATUS.REFUNDED:
        filter = 'refundedDateRange';
        filterFrom = 'refundedDateFrom';
        filterTo = 'refundedDateTo';
        headerText = 'Refunded Date Range';
        break;
      default:
        break;
    }
    return filter && !this.props.projectUnitID && (
      <Grid.Column
        className="filter tight-column"
        mobile={16}
        tablet={5}
        computer={5}
        style={{ paddingBottom: isMobile ? '1rem' : '0rem' }}
      >
        <BookingDatePicker
          filterName={filter}
          filterNameFrom={filterFrom}
          filterNameTo={filterTo}
          headerText={t(headerText, { ns: TRANSLATION_FILES.screens })}
          placeholder={t(`Select ${headerText}`, { ns: TRANSLATION_FILES.screens })}
          dateFrom={this.state[filterFrom]}
          dateTo={this.state[filterTo]}
          onChange={this.handleFilterOnChange}
          onClose={this.handleClearFilter}
          onResetRange={this.handleClearFilter}
          onSetRange={(from, to) => this.handleSetDateRange(filter, from, to)}
          value={this.state[filter]}
          disabled={loading}
          label={t(headerText, { ns: TRANSLATION_FILES.screens })}
        />
      </Grid.Column>
    );
  }
  renderDefaultClearFilter = () => {
    const { isMobile } = this.state;
    return (
      (this.getAllFilterNames().some(filterName => this.state[filterName] &&
        this.state[filterName].length > 0) || this.state.search.length > 0) && (
        <Grid.Row style={{ paddingBottom: '0rem', paddingTop: isMobile ? '0rem' : '1rem' }}>
          <Grid.Column
            verticalAlign="middle"
          >
            <Button
              className="uc-clear-button"
              content="Clear all"
              onClick={() => this.handleClearFilter(...this.getAllFilterNames())}
            />
          </Grid.Column>
        </Grid.Row>)
    );
  }
  handleResetAll = () => {
    const cleanQuery = {};
    this.setState({
      srCodeInput: '',
      sr_code: '',
      search: '',
      customerNameInput: '',
      customer_name: '',
      opportunityStatus: '',
      srStatus: '',
      paymentStatus: [],
      paymentRefundStatus: [],
      sourceOfFinance: '',
      loanStatus: [],
      filteredProjects: [],
      currentPage: 1,
    }, () => {
      this.replaceQuery(cleanQuery, true, true);
    });
  }
  renderAccordionDefaultView = (searchAreas) => {
    const { projectUnitID, t } = this.props;
    const { loading, loadingProjectSearch, activeAccordionIndex, isTablet, isMobile } = this.state;
    return (
      <Accordion fluid className="uc-accordion shadow-border" style={{ paddingBottom: !isMobile && activeAccordionIndex !== 0 ? '1.5rem' : '0.5rem' }}>
        <Accordion.Title
          style={{ paddingBottom: '1rem' }}
          active={activeAccordionIndex === 0}
          index={0}
        >
          <Grid>
            <Grid.Row columns="equal" style={{ paddingBottom: activeAccordionIndex === 0 ? '1rem' : '0rem' }}>
              <Grid.Column
                className="tight-column"
                tablet={5}
                computer={5}
              >
                <SearchIn
                  isLoading={loading}
                  onChange={this.handleFilterOnChange}
                  onSearchInChange={this.handleFilterOnChange}
                  onClear={this.handleClearFilter}
                  search={this.state.search}
                  searchIn={this.state.searchIn}
                  options={searchAreas}
                  label={t('Keywords', { ns: TRANSLATION_FILES.screens })}
                />
              </Grid.Column>
              {
                !projectUnitID && (
                  <Grid.Column
                    className="filter tight-column"
                    tablet={5}
                    computer={5}
                  >
                    <div className="field">
                      <label
                        className="ui"
                        htmlFor="projectFilter"
                        style={{ fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }}
                      >
                        {t('Projects', { ns: TRANSLATION_FILES.screens })}
                      </label>
                      <Dropdown
                        fluid
                        search
                        selection
                        floating
                        disabled={loading || loadingProjectSearch}
                        loading={loadingProjectSearch}
                        multiple
                        name="projectFilter"
                        onChange={this.handleFilterProjects}
                        options={this.state.projectOpts}
                        placeholder={t('Find Project')}
                        value={this.state.filteredProjects[0] || ''}
                      />
                    </div>
                  </Grid.Column>
                )
              }
              <Grid.Column
                className="filter tight-column"
                tablet={5}
                computer={5}
              >
                <BookingSelectListMultiple
                  filterName="Booking Status"
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  options={SINGLE_STATUS_FILTER_OPTIONS.map(({ value, text }) => ({ value, text: `${t(text, { ns: TRANSLATION_FILES.constants })} (${this.getIndividualStatusCount(value)})` }))}
                  placeholder={t('Booking Status')}
                  value={this.state.srStatus}
                  disabled={loading}
                  label={t('Booking Status', { ns: TRANSLATION_FILES.screens })}
                  selectedText={t('selected', { ns: TRANSLATION_FILES.translation })}
                />
              </Grid.Column>
              <Grid.Column width={1} style={{ paddingLeft: isTablet ? '0rem' : '0.7rem' }} textAlign="left">
                <Popup
                  size="tiny"
                  style={{ backgroundColor: '#596975' }}
                  basic
                  inverted
                  content={activeAccordionIndex === 0 ? t('Collapse', { ns: TRANSLATION_FILES.translation }) : t('Expand', { ns: TRANSLATION_FILES.translation })}
                  position="bottom center"
                  trigger={
                    <Button
                      icon
                      circular
                      onClick={e => this.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 })}
                      className={`uc-accordion-toggle-btn ${activeAccordionIndex === 0 ? 'rotated' : ''}`}
                    >
                      <Icon name="chevron down" />
                    </Button>
                  }
                />
              </Grid.Column>
            </Grid.Row>
            {activeAccordionIndex !== 0 && this.renderDefaultClearFilter()}
          </Grid>
        </Accordion.Title>
        <Transition visible={activeAccordionIndex === 0} animation="slide down" duration={200}>
          <Accordion.Content active={activeAccordionIndex === 0} style={{ paddingBottom: '2rem' }}>
            <Grid
              textAlign="left"
              verticalAlign="middle"
            >
              <Grid.Row style={{ paddingBottom: '0rem' }}>
                <Grid.Column
                  className="filter tight-column"
                  tablet={5}
                  computer={5}
                >
                  <BookingSelectListMultiple
                    filterName="paymentRefundStatus"
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    options={PAYMENT_REFUND_STATUSES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                    value={this.state.paymentRefundStatus}
                    placeholder={t('Payment Refund Status')}
                    disabled={loading}
                    label={t('Payment Refund Status', { ns: TRANSLATION_FILES.screens })}
                  />
                </Grid.Column>
                <Grid.Column
                  className="filter tight-column"
                  tablet={5}
                  computer={5}
                >
                  <BookingSelectList
                    filterName="sourceOfFinance"
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    options={SOURCE_OF_FINANCE_STATUSES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                    value={this.state.sourceOfFinance}
                    disabled={loading}
                    label={t('Source of finance', { ns: TRANSLATION_FILES.screens })}
                  />
                </Grid.Column>
                <Grid.Column
                  className="filter tight-column"
                  tablet={5}
                  computer={5}
                >
                  <BookingDatePicker
                    filterName="dateRange"
                    filterNameFrom="dateFrom"
                    filterNameTo="dateTo"
                    headerText={t('Created Date Range')}
                    placeholder={t('Select Created Date Range')}
                    dateFrom={this.state.dateFrom}
                    dateTo={this.state.dateTo}
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    onResetRange={this.handleClearFilter}
                    onSetRange={(from, to) => this.handleSetDateRange('dateRange', from, to)}
                    value={this.state.dateRange}
                    disabled={loading}
                    label={t('Created Date Range')}
                  />
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ paddingBottom: '0rem' }}>
                {this.renderStatusDateFilter()}
              </Grid.Row>
              {this.renderDefaultClearFilter()}
            </Grid>
          </Accordion.Content>
        </Transition>
      </Accordion>
    );
  }
  renderAccordionMobileView = (searchAreas) => {
    const { projectUnitID, t } = this.props;
    const { loading, loadingProjectSearch, activeAccordionIndex } = this.state;
    return (
      <Accordion fluid className="uc-accordion shadow-border">
        <Accordion.Title
          // style={{ paddingBottom: '1rem' }}
          active={activeAccordionIndex === 0}
          index={0}
        >
          <Grid>
            <Grid.Row>
              <Grid.Column
                style={{ paddingBottom: activeAccordionIndex !== 0 ? '1rem' : '0rem' }}
                width={16}
              >
                <SearchIn
                  isLoading={loading}
                  onChange={this.handleFilterOnChange}
                  onSearchInChange={this.handleFilterOnChange}
                  onClear={this.handleClearFilter}
                  search={this.state.search}
                  searchIn={this.state.searchIn}
                  options={searchAreas}
                  isFullSize
                  label={t('Keywords', { ns: TRANSLATION_FILES.screens })}
                />
              </Grid.Column>
              {
                activeAccordionIndex !== 0 && <Grid.Column width={16} textAlign="center">
                  <Popup
                    size="tiny"
                    style={{ backgroundColor: '#596975' }}
                    basic
                    inverted
                    content={activeAccordionIndex === 0 ? t('Collapse') : t('Expand')}
                    position="bottom center"
                    trigger={
                      <Button
                        onClick={e => this.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 })}
                        className={'uc-accordion-toggle-btn'}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                          <span style={{ fontSize: '12px', fontWeight: '400' }}>{t('More')}</span>
                          <Icon style={{ fontSize: '12px', fontWeight: '400' }} name="chevron down" />
                        </div>
                      </Button>
                    }
                  />
                </Grid.Column>
              }
            </Grid.Row>
          </Grid>
        </Accordion.Title>
        <Transition visible={activeAccordionIndex === 0} animation="slide down" duration={200}>
          <Accordion.Content active={activeAccordionIndex === 0}>
            <Grid
              textAlign="left"
              verticalAlign="middle"
            >
              <Grid.Row style={{ paddingBottom: '0rem' }}>
                {
                  !projectUnitID && (
                    <Grid.Column
                      className="filter"
                      width={16}
                      style={{ paddingBottom: '1rem' }}
                    >
                      <div className="field">
                        <label
                          className="ui"
                          htmlFor="projectFilter"
                          style={{ fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }}
                        >
                          {t('Projects', { ns: TRANSLATION_FILES.screens })}
                        </label>
                        <Dropdown
                          fluid
                          search
                          selection
                          floating
                          disabled={loading || loadingProjectSearch}
                          loading={loadingProjectSearch}
                          multiple
                          name="projectFilter"
                          onChange={this.handleFilterProjects}
                          options={this.state.projectOpts}
                          placeholder={t('Find Project')}
                          value={this.state.filteredProjects}
                        />
                      </div>
                    </Grid.Column>
                  )
                }
                <Grid.Column
                  className="filter"
                  width={16}
                  style={{ paddingBottom: '1rem' }}
                >
                  <BookingSelectListMultiple
                    filterName="Booking Status"
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    options={SINGLE_STATUS_FILTER_OPTIONS.map(({ value, text }) => ({ value, text: `${t(text, { ns: TRANSLATION_FILES.constants })} (${this.getIndividualStatusCount(value)})` }))}
                    placeholder={t('Booking Status')}
                    value={this.state.srStatus}
                    disabled={loading}
                    label={t('Booking Status', { ns: TRANSLATION_FILES.screens })}
                  />
                </Grid.Column>
                <Grid.Column
                  className="filter"
                  width={16}
                  style={{ paddingBottom: '1rem' }}
                >
                  <BookingDatePicker
                    filterName="dateRange"
                    filterNameFrom="dateFrom"
                    filterNameTo="dateTo"
                    headerText={t('Created Date Range')}
                    placeholder={t('Select Created Date Range', { ns: TRANSLATION_FILES.screens })}
                    dateFrom={this.state.dateFrom}
                    dateTo={this.state.dateTo}
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    onResetRange={this.handleClearFilter}
                    onSetRange={(from, to) => this.handleSetDateRange('dateRange', from, to)}
                    value={this.state.dateRange}
                    disabled={loading}
                    label={t('Created Date Range', { ns: TRANSLATION_FILES.screens })}
                  />
                </Grid.Column>
                {this.renderStatusDateFilter()}
              </Grid.Row>
              {this.renderDefaultClearFilter()}
              {
                activeAccordionIndex === 0 &&
                  <Grid.Column width={16} style={{ paddingTop: '0rem' }} textAlign="center">
                    <Popup
                      size="tiny"
                      style={{ backgroundColor: '#596975' }}
                      basic
                      inverted
                      content={activeAccordionIndex === 0 ? t('Collapse') : t('Expand')}
                      position="bottom center"
                      trigger={
                        <Button
                          onClick={e => this.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 })}
                          className={'uc-accordion-toggle-btn'}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                            <span style={{ fontSize: '12px', fontWeight: '400' }}>{t('Less')}</span>
                            <Icon style={{ fontSize: '12px', fontWeight: '400' }} name="chevron up" />
                          </div>
                        </Button>
                      }
                    />
                  </Grid.Column>
              }
            </Grid>
          </Accordion.Content>
        </Transition>
      </Accordion>
    );
  }
  renderMenuTool = () => {
    const { t } = this.props;
    const { isMobile } = this.state;
    const searchAreas = [
      { value: 'all', text: t('All', { ns: TRANSLATION_FILES.constants }) },
      { value: 'purchaser', text: t('Purchaser', { ns: TRANSLATION_FILES.constants }) },
      { value: 'assigned_agent', text: t('Assigned Agent', { ns: TRANSLATION_FILES.constants }) },
    ];
    return (
      <Grid columns="equal">
        <Grid.Row>
          <Grid.Column>
            {
              isMobile ? (
                <BookingStatusDropdown
                  options={OPPORTUNITY_STATUSES_TABS.map(status => ({
                    key: status.value,
                    value: status.value,
                    count: this.getStatusCount(status.value),
                    valueLabel: t(status.text, { ns: TRANSLATION_FILES.constants }),
                    className: status.className,
                  }))}
                  onChange={(e) => {
                    if (SINGLE_STATUS_TAB_VALUES.indexOf(e) > -1) {
                      this.handleSingleStatusOnChange(e);
                    } else if (e === DEFAULT_OPPORTUNITY_STATUS) {
                      this.handleReplaceStatus();
                    } else {
                      this.handleReplaceStatus(e);
                    }
                  }}
                  value={this.isSingleStatusTabActive()
                    ? this.state.srStatus
                    : (this.state.opportunityStatus === '' ? OPPORTUNITY_STATUS_MAP[DEFAULT_OPPORTUNITY_STATUS].value : this.state.opportunityStatus)}
                />
              ) : (
                <Grid
                  className="status"
                  columns="equal"
                  textAlign="left"
                  verticalAlign="bottom"
                >
                  <Grid.Row style={{ paddingTop: 0 }}>
                    {
                      OPPORTUNITY_STATUSES_TABS.map((status, key) => (
                        <FixedBarStatus
                          key={key}
                          className={status.className}
                          status={status.value}
                          name={t(status.text, { ns: TRANSLATION_FILES.constants })}
                          count={this.getStatusCount(status.value)}
                          selected={this.getSelectedStatus(status.value)}
                          onClick={
                            status.singleStatus
                              ? this.handleSingleStatusOnChange
                              : (status.value === DEFAULT_OPPORTUNITY_STATUS ? () => this.handleReplaceStatus() : this.handleReplaceStatus)
                          }
                          style={{ maxWidth: 'none' }}
                        />
                      ))
                    }
                  </Grid.Row>
                </Grid>
              )
            }
          </Grid.Column>
        </Grid.Row>
          <Grid.Row style={{ paddingTop: '0.5rem' }}>
            <Grid.Column width={16}>
              <div className="uc-accordion shadow-border" style={{ padding: '0.75rem 1.5rem' }}>
                <Grid>
                  <Grid.Row style={{ paddingTop: '0.5rem', paddingBottom: '0.5rem' }}>
                    <Grid.Column tablet={5} computer={4}>
                      <BookingSelectList
                        filterName="sr_status" // Updates query tracking mapping to target row status fields
                        onChange={(value) => this.handleSingleStatusOnChange(value === '__all__' ? '' : value)}
                        options={[
                          { value: '__all__', text: t('All Statuses', { ns: TRANSLATION_FILES.constants }) },
                          ...SINGLE_STATUS_FILTER_OPTIONS.map(({ value, text }) => ({
                            value,
                            text: `${t(text, { ns: TRANSLATION_FILES.constants })} (${this.getIndividualStatusCount(value)})`
                          })),
                        ]}
                        placeholder={t('Select Status')}
                        value={this.state.srStatus || '__all__'}
                        disabled={this.state.loading}
                        label={t('Booking Status', { ns: TRANSLATION_FILES.screens })}
                      />
                    </Grid.Column>
                    <Grid.Column
                      className="tight-column"
                      tablet={5}
                      computer={5}
                    >
                      <div className="field">
                        <label className="opportunity-search">
                          {t('Booking ID', { ns: TRANSLATION_FILES.screens })}
                        </label>
                        <Input
                          fluid
                          placeholder={t('Search Booking ID...', { ns: TRANSLATION_FILES.constants })}
                          value={this.state.srCodeInput}
                          disabled={this.state.loading}
                          onChange={(e, { value }) => this.setState({ srCodeInput: value })}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.handleFilterOnChange(this.state.srCodeInput, 'sr_code');
                            }
                          }}
                          action={{
                            icon: 'search',
                            color: 'teal',
                            basic: true,
                            disabled: this.state.loading,
                            onClick: () => this.handleFilterOnChange(this.state.srCodeInput, 'sr_code'),
                          }}
                        />
                      </div>
                    </Grid.Column>
                    <Grid.Column className="tight-column" tablet={4} computer={4}>
                      <div className="field">
                        <label className="opportunity-search">
                          {t('Purchaser Name', { ns: TRANSLATION_FILES.screens })}
                        </label>
                        <Input
                          fluid
                          placeholder={t('Search Customer Name...', { ns: TRANSLATION_FILES.constants })}
                          value={this.state.customerNameInput}
                          disabled={this.state.loading}
                          onChange={(e, { value }) => this.setState({ customerNameInput: value })}
                          onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                              this.handleFilterOnChange(this.state.customerNameInput, 'customer_name');
                            }
                          }}
                          action={{
                            icon: 'search',
                            color: 'teal',
                            basic: true,
                            disabled: this.state.loading,
                            onClick: () => this.handleFilterOnChange(this.state.customerNameInput, 'customer_name'),
                          }}
                        />
                      </div>
                    </Grid.Column>
                    <Grid.Column
                      tablet={3}
                      computer={3}
                      verticalAlign="bottom"
                      textAlign="right"
                      style={{ paddingBottom: '2px' }}
                    >
                      <Button
                        basic
                        size="small"
                        icon="refresh"
                        color="black"
                        content={t('Clear', { ns: TRANSLATION_FILES.constants })}
                        disabled={this.state.loading}
                        onClick={this.handleResetAll}
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </div>
            </Grid.Column>
          </Grid.Row>
      </Grid>
    );
  }
  renderStatusDateCell = (isHeader, data = {}) => {
    const { t } = this.props;
    const { opportunityStatus } = this.state;
    let label = '';
    let date = '';
    switch (opportunityStatus) {
      case OPPORTUNITY_STATUS.APPROVED:
        label = OPPORTUNITY_STATUS_MAP[OPPORTUNITY_STATUS.APPROVED].text;
        date = data.lastExpiredAt;
        break;
      case OPPORTUNITY_STATUS.PENDING_CANCELLATION:
        label = OPPORTUNITY_STATUS_MAP[OPPORTUNITY_STATUS.PENDING_CANCELLATION].text;
        date = data.lastSoldAt;
        break;
      // OPPORTUNITY_STATUS_MAP is keyed by tab value, and the Error tab's value is now the group.
      case OPPORTUNITY_STATUS_GROUP.ERROR:
        label = OPPORTUNITY_STATUS_MAP[OPPORTUNITY_STATUS_GROUP.ERROR].text;
        date = data.lastSoldAt;
        break;
      case OPPORTUNITY_STATUS.PENDING_REFUND:
        label = OPPORTUNITY_STATUS_MAP[OPPORTUNITY_STATUS.PENDING_REFUND].text;
        date = data.lastSoldAt;
        break;
      case OPPORTUNITY_STATUS.REFUNDED:
        label = OPPORTUNITY_STATUS_MAP[OPPORTUNITY_STATUS.REFUNDED].text;
        date = data.lastSoldAt;
        break;
      default:
        break;
    }
    if (isHeader) {
      return (
        <span>
          {t('Created')}
          {
            !this.props.projectUnitID && label && (
              <span>
                &nbsp;&amp;
                <br />
                {t(label, { ns: TRANSLATION_FILES.constants })}
              </span>
            )
          }
        </span>
      );
    }
    return !this.props.projectUnitID && date && (
      <small>
        <Timestamp
          timestamp={date}
          format="DD/M/YYYY HH:mm:ss"
        />
      </small>
    );
  }
  renderTableHeaders = (sortItems) => {
    const { t } = this.props;
    return (
      <Table.Header className="mobile-hide">
        <Table.Row>
          <Table.HeaderCell
            style={{ cursor: 'pointer', userSelect: 'none' }}
            sorted={this.cellCheckSorted('created_at')}
            onClick={() => this.handleCellSort('created_at')}
          >
            {this.renderStatusDateCell(true)}
          </Table.HeaderCell>
          <Table.HeaderCell collapsing className="mobile-hide">{t('Booking ID')}</Table.HeaderCell>
          <Table.HeaderCell className="mobile-hide">{t('Project')}</Table.HeaderCell>
          <Table.HeaderCell className="mobile-hide">{t('Purchaser')}</Table.HeaderCell>
          <Table.HeaderCell >{t('Assigned Agent')}</Table.HeaderCell>
          <Table.HeaderCell className="mobile-hide">{t('Payment Amount (VND)')}</Table.HeaderCell>
          <Table.HeaderCell className="mobile-hide">{t('Source of Finance')}</Table.HeaderCell>
          <Table.HeaderCell
            collapsing
            // sorted={this.cellCheckSorted(sortItems[4].sortColumn)}
            // onClick={() => this.handleCellSort(sortItems[4].sortColumn)}
            className="uc-sticky-col uc-right"
          >{t('Status')}</Table.HeaderCell>
          <Table.HeaderCell collapsing className="uc-sticky-col uc-right">{t('Progress')}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }
  renderProgressCell = (data) => {
    const { t } = this.props;
    const iconSize = 18;
    const bookingStatus = data && data.sr_status ? data.sr_status : null;
    const financeStatus = data && data.sr_source_of_finance ? data.sr_source_of_finance : null;
    const bookingIcon = (
      <img
        src={this.getBookingIcon(bookingStatus)}
        width={iconSize}
        alt="booking status"
      />
    );
    const loanIcon = (
      <img
        src={this.getSourceOfFinanceIcon(financeStatus)}
        width={iconSize}
        alt="loan"
      />
    );
    const docIcon = (
      <img
        src={DocumentBlackSvg}
        width={iconSize}
        alt="notes"
      />
    );
    return (
      <div className="verticalAlign-mid" style={{ display: 'inline-flex', justifyContent: 'start', gap: 16 }}>
        <InfoPopup
          // touchAsClicked={!isComputer}
          trigger={bookingIcon}
          content={`${t(bookingStatus && SINGLE_STATUS_MAP[bookingStatus] ? SINGLE_STATUS_MAP[bookingStatus].text : 'None', { ns: TRANSLATION_FILES.constants })}`}
        />
        <InfoPopup
          // touchAsClicked={!isComputer}
          trigger={loanIcon}
          content={`${t(financeStatus && SOURCE_OF_FINANCE_STATUS_MAP[financeStatus] ? SOURCE_OF_FINANCE_STATUS_MAP[financeStatus].text : 'None', { ns: TRANSLATION_FILES.constants })}`}
        />
        <InfoPopup
          // touchAsClicked={!isComputer}
          trigger={docIcon}
          content={`${t('Document uploaded')}`}
        />
      </div>
    );
  }
  renderTableRow = (data, idx) => {
    const {
      isMobile,
    } = this.state;
    const { t } = this.props;

    const prepData = {
      id: '',
      code: '',
      name: '',
      createdAt: '',
      statusID: '',
      status: '',
      statusName: '',
      origin: '',
      buyerProfileID: '',
      created_at: '',
      bookingCustomer: null,
      paymentStatus: '',
      ...data,
    };
    prepData.project = { shortName: '', name: '', ...((data && data.project) || {}) };
    const statusValue = (prepData.sr_status && SINGLE_STATUS_MAP[prepData.sr_status]) || SINGLE_STATUS_MAP[OPPORTUNITY_STATUS.PENDING_PAYMENT];
    const statusTag = <StatusFlag text={t(statusValue.text, { ns: TRANSLATION_FILES.constants })} value={`opportunity-${statusValue.value}`} />;
    return (
      <Table.Row
        key={idx}
        className={this.getRowClassName(prepData.statusID)}
        {...this.getDataTarget(idx)}
        {...this.getDatasetAttributes('bookingid', prepData.booking_id)}
        {...this.getDatasetAttributes('unitno', prepData.unit_number)}
        {...this.getDatasetAttributes('projectname', prepData.project_name)}
        {...this.getDatasetAttributes('purchasername', prepData.primary_customer ? prepData.primary_customer.name : '')}
        onClick={isMobile ? () => this.context.router.push(`/opportunities/${prepData.id}/`) : null}
      >
        <Table.Cell>
          <span className="mobile-hide">
            <Timestamp
              timestamp={prepData.created_at}
              format="DD/M/YYYY HH:mm:ss"
            />
            <br />
            {this.renderStatusDateCell(false, prepData)}
          </span>
          {
            <span className="computer-hide">
              <Link to={`/opportunities/${prepData.id}/`}>
                {prepData.primary_customer ? prepData.primary_customer.name : ''}
              </Link>
            </span>
          }
        </Table.Cell>
        {
          isMobile && (
            <Table.Cell style={{ marginTop: '0.45em' }}>
              {statusTag}
            </Table.Cell>
          )
        }
        <Table.Cell collapsing className="mobile-hide">
          <Link to={`/opportunities/${prepData.id}/`}>
            {prepData.sr_code || '-'}
          </Link>
        </Table.Cell>
        <Table.Cell className="mobile-hide">
          {titleCase(prepData.project_name || '')}
        </Table.Cell>
        <Table.Cell className="mobile-hide">
          <Link to={`/opportunities/${prepData.id}/?section=purchaser`}>
            {prepData.primary_customer ? prepData.primary_customer.name : ''}
          </Link>
        </Table.Cell>
        <Table.Cell className="mobile-hide">{prepData.assign_to_name || ''}</Table.Cell>
        <Table.Cell className="mobile-hide">
          {(() => {
            const token = prepData.unit_reservation_token;
            const amountMinor = (token && token.amountMinorPaid) || 0;
            const code = (token && token.currencyCode) || 'VND';
            return formatMinorAmount(amountMinor, code);
          })()}
        </Table.Cell>
        <Table.Cell className="mobile-hide">
          {prepData.sr_source_of_finance && SOURCE_OF_FINANCE_STATUS_MAP[prepData.sr_source_of_finance] ? t(SOURCE_OF_FINANCE_STATUS_MAP[prepData.sr_source_of_finance].text, { ns: TRANSLATION_FILES.constants }) : ''}
        </Table.Cell>
        {
          !isMobile && (
            <Table.Cell collapsing className="uc-sticky-col uc-right">
              {statusTag}
            </Table.Cell>
          )
        }
        {
          isMobile ? (
            <Table.Cell style={{ marginTop: '0.5em' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'middle',
                  justifyContent: 'space-between',
                  width: '100%',
                }}
              >
                {this.renderProgressCell(prepData)}
              </div>
            </Table.Cell>
          ) : (
            <Table.Cell className="uc-sticky-col uc-right">
              {this.renderProgressCell(prepData)}
            </Table.Cell>
          )
        }
      </Table.Row>
    );
  }
  render() {
    const { loading, data, cursorPaginations, limit, nextCursor, count, offset, tokenStatus, currentPage } = this.state;
    const isTokenFilter = !!tokenStatus && tokenStatus !== 'pending_payment';
    const { t } = this.props;
    const sortItems = [];
    sortItems.push(...this.statusDateSortItems());
    const isMalaysia = this.props.auth.company && this.props.auth.company.countryCode === 'my';
    const exportItems = this.exportItemsManager();
    if (isMalaysia) {
      exportItems.push(
        {
          text: 'Excel',
          icon: 'download',
          href: this.exportURL('excel'),
        },
        {
          text: 'CSV',
          icon: 'download',
          href: this.exportURL('csv'),
        },
        {
          isDivider: true,
        },
      );
    }
    return (
      <Grid verticalAlign="middle" padded="vertically">
        <Grid.Row>
          <Grid.Column>
            {this.renderMenuTool()}
          </Grid.Column>
        </Grid.Row>

        {/* List Data */}
        <Grid.Row>
          <Grid.Column>
            <Dimmer
              inverted style={{ zIndex: 20 }}
              active={loading && data.length > 0}
            >
              <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
            </Dimmer>
            <Grid>
              <Grid.Row>
                <Grid.Column mobile={10} tablet={6} computer={6} verticalAlign="middle">
                  <Header as="h3">{this.getTabHeader()}</Header>
                </Grid.Column>
                <Grid.Column mobile={6} tablet={10} computer={10}>
                  {
                    // CPI-1281: Vietnam downloads run as a queued export (the CRM list pages behind a
                    // short-lived cursor), so the icon opens the Booking Exports page with these filters.
                    isVietnamCompany(this.props.auth) && (
                      <div style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <Popup
                          size="tiny"
                          style={{ backgroundColor: '#596975' }}
                          basic
                          inverted
                          content={t('Download', { ns: TRANSLATION_FILES.translation })}
                          position="bottom center"
                          trigger={
                            <Link
                              to={exportsPagePath(exportFiltersFromQuery(decodeSearch(this.props.location.search)))}
                              data-bot-target="download-bookings"
                              style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '50%',
                                padding: '11px',
                                transition: 'background-color 0.2s ease',
                                cursor: 'pointer',
                              }}
                              onMouseEnter={(e) => {
                                const { currentTarget } = e;
                                currentTarget.style.backgroundColor = '#f4f5f7';
                              }}
                              onMouseLeave={(e) => {
                                const { currentTarget } = e;
                                currentTarget.style.backgroundColor = 'transparent';
                              }}
                            >
                              <img src={DownloadSvg} width={20} alt="download" />
                            </Link>
                          }
                        />
                      </div>
                    )
                  }
                  {/* TODO: temp hide these download/sort buttons waiting CRM side to add */}
                  {/* <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                    {
                      exportItems.length > 0 && (
                        <Popup
                          size="tiny"
                          style={{ backgroundColor: '#596975' }}
                          basic
                          inverted
                          disabled={!isComputer}
                          content={t('Download', { ns: TRANSLATION_FILES.translation })}
                          position="bottom center"
                          trigger={
                            <div>
                              <SortButton
                                floated="right"
                                icon={
                                  <div
                                    style={{
                                      display: 'inline-flex',
                                      alignItems: 'center',
                                      justifyContent: 'center',
                                      borderRadius: '50%',
                                      padding: '11px',
                                      transition: 'background-color 0.2s ease',
                                      cursor: 'pointer',
                                    }}
                                    onMouseEnter={(e) => {
                                      const { currentTarget } = e;
                                      currentTarget.style.backgroundColor = '#f4f5f7';
                                    }}
                                    onMouseLeave={(e) => {
                                      const { currentTarget } = e;
                                      currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                  >
                                    <img src={DownloadSvg} width={20} alt="download" />
                                  </div>
                                }
                                loading={loading}
                                items={exportItems}
                              />
                            </div>
                          }
                        />
                      )
                    }
                    <Popup
                      size="tiny"
                      style={{ backgroundColor: '#596975' }}
                      basic
                      inverted
                      disabled={!isComputer}
                      content={t('Sort')}
                      position="bottom center"
                      trigger={
                        <div>
                          <SortButton
                            floated="right"
                            icon={
                              <div
                                style={{
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  borderRadius: '50%',
                                  padding: '8px',
                                  transition: 'background-color 0.2s ease',
                                  cursor: 'pointer',
                                }}
                                onMouseEnter={(e) => {
                                  const { currentTarget } = e;
                                  currentTarget.style.backgroundColor = '#f4f5f7';
                                }}
                                onMouseLeave={(e) => {
                                  const { currentTarget } = e;
                                  currentTarget.style.backgroundColor = 'transparent';
                                }}
                              >
                                <img src={SortSvg} width={24} alt="sort" />
                              </div>
                            }
                            loading={loading}
                            items={sortItems}
                            onSort={this.handleSortData}
                          />
                        </div>
                      }
                    />
                  </div> */}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column width={16}>
                  <div style={{ overflowX: 'auto' }}>
                    <Table className="uc-table uc-booking-list-table" basic="very" sortable>
                      {this.renderTableHeaders(sortItems)}
                      <Table.Body>
                        {
                          data.length > 0 ?
                            data.map(this.renderTableRow) : (
                              <Table.Row>
                                <Table.Cell colSpan={11} textAlign="center">
                                  {
                                    loading ?
                                      <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                                    : <p>{t('No bookings found')}.</p>
                                  }
                                </Table.Cell>
                              </Table.Row>
                            )
                        }
                      </Table.Body>
                    </Table>
                  </div>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column textAlign="center">
            <PageNav
              upward
              isCursorPagination={!isTokenFilter}
              currentPage={isTokenFilter ? currentPage : cursorPaginations.length + 1}
              nextCursor={nextCursor}
              cursorStack={cursorPaginations}
              count={count}
              limit={limit}
              offset={offset}
              dataSize={data.length}
              loading={loading}
              onChange={isTokenFilter ? this.handleChangePageOffset : param => this.handlePageChange(param)}
              noScrollTop={this.props.noScrollTop}
            />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}

export default withTranslation(namespaces)(withRouter(connect(OpportunityList.mapStateToProps)(OpportunityList)));



// WEBPACK FOOTER //
// ./src/components/Opportunities/OpportunityList.jsx